// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldFunctionBox_wrapper__smeCf"};